<template>

<component :is="el" :label="label" :required="required">

    <el-cascader
      style="width:100%;"
      v-model="values"
      :placeholder="placeholder"
      :options="categories"
      :disabled="disabled"
      :show-all-levels="showLevels"
      :allow-create="create"
      :size="size"
      @change="updated">
    </el-cascader>


</component>

</template>



<script>

import ArrayMixins from '@/mixins/ArrayMixins'

export default {
  mixins: [ArrayMixins],

  name: 'select-structure',


  props: {

    label: {
      type: String,
      default: 'Structure'
    },

    value: {
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    disabledText: {
      type: String,
      default: null
    },

    required: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'normal'
    },

    placeholder: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    showLevels: {
      type: Boolean,
      default: true
    },

    returnLevels: {
      type: Boolean,
      default: false
    },

    create: {
      type: Boolean,
      default: true
    },

    noForm: {
      type: Boolean,
      default: false
    }
  },



  methods: {

    updated (selected) {

      if (this.isArray(this.formData)) {

        this.formData = selected
        this.$emit('input', selected)
        this.$emit('change', selected)

      } else {

        if (this.returnLevels) {
          var value = ''

          for (var i = 0; i <= 4; i++) {

            if (selected[i]) {
              value += (i > 0 ? ' / ' : '') + selected[i]
            }
          }

          this.formData = value
          this.$emit('input', value)
          this.$emit('change', value)

        } else {

          let value = selected[selected.length - 1]

          this.$emit('input', value)
          this.$emit('change', value)

        }

      }
    }

  },



  data () {

    return {
      el: this.noForm ? 'div' : 'el-form-item',
      formData: this.value,
      name: this.disabledText,
      values: [],
      categories: this.getConfig().structures
//      categories: structureTypeData
    }

  },



  mounted () {

    if (this.name) {
      this.values = this.name.split(' / ')

      this.values = this.find('label', this.values, this.categories, 'children', 'value')
    } // if

  }

}
</script>
